<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex lg12>
          <v-card>
            <v-flex lg12>
              <v-card v-if="usuarioLoggedTipe == 'ADMINISTRADOR'">
                <v-toolbar card color="white">
                  <v-spacer></v-spacer>
                  <v-toolbar-title class="indigo--text"
                    >Carga Video Tutorial
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-actions class="pb-3">
                  <v-spacer></v-spacer>
                  <v-flex>
                    <v-text-field
                      v-model="descripcionValue"
                      label="Descripción"
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <data-adjunto
                      :key="adminAdjunto"
                      :documentoId="id"
                      :tipeView="tipeView"
                      :tipeArchive="tipeArchive"
                    >
                    </data-adjunto>
                  </v-flex>
                  <v-btn
                    :loading="loading"
                    color="success"
                    dark
                    class="mb-2"
                    @click="cargaVideo()"
                  >
                    cargar
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-flex>
            <v-toolbar card color="white">
              <v-toolbar-title class="indigo--text"
                >Seleccione sus opciones</v-toolbar-title
              >
            </v-toolbar>
            <v-container>
              <v-layout>
                <v-flex xs12 md4>
                  <v-select
                    v-model="nombreValue"
                    :items="nombreSelect"
                    label="Nombre"
                    data-vv-name="listaNombres"
                  ></v-select>
                </v-flex>
                <v-btn
                  fab
                  dark
                  color="teal"
                  title="Filtrar registros"
                  @click="filterVideos()"
                >
                  <v-icon dark>filter_list</v-icon>
                </v-btn>
                <v-btn
                  fab
                  dark
                  color="red darken-4"
                  title="Limpiar filtros"
                  @click="clear()"
                >
                  <v-icon dark>clear_all</v-icon>
                </v-btn>
              </v-layout>
            </v-container>
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text"
                >Registro de Videos</v-toolbar-title
              >
              <v-spacer></v-spacer>
            </v-toolbar>
            <div v-if="loading">
              <loading></loading>
            </div>
            <div v-if="alerta">
              <alert-empty></alert-empty>
            </div>
            <grid-videos
              :key="indexGridVideo"
              :itemsVideos="itemsVideos"
              :rowsTable="rowsTable"
            ></grid-videos>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import { async } from "q";
import { log } from "util";
import DataAdjunto from "@/components/AdjuntoData.vue";
import GridVideos from "@/modules/configuration/videoTutoriales/views/GridVideos.vue";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";

export default {
  name: "registro-civil",
  components: {
    DataAdjunto,
    GridVideos,
    AlertEmpty,
    Loading,
  },
  data() {
    return {
      loading: false,
      alerta: false,
      rowsTable: [20],
      itemsVideos: [],
      indexGridVideo: 0,
      nombreSelect: [],
      nombreValue: null,
      filter: false,
      tipeArchive: "",
      base64Value: "",
      filenameValue: "",
      descripcionValue: "",
      id: "",
      tipeView: "",
      adminAdjunto: 10,
    };
  },

  created() {
    this.tipeArchive = "*";
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;

    this.loadDataVideo();
  },
  mounted() {},
  computed: {},
  methods: {
    async loadDataVideo() {
      this.loading = true;

      this.itemsVideos = await this.loadVideoAll();
      this.loading = false;
      if (this.itemsVideos.length > 0) {
        this.alerta = false;
      } else {
        this.alerta = true;
      }
      this.loadNombreSelect();
    },
    async loadVideoAll() {
      this.body = {
        filename:
          this.nombreValue && this.nombreValue != null
            ? this.nombreValue
            : null,
      };

      return await axios
        .post("/public/findFilters", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async cargaVideo() {
      await this.cargar();
      this.reloadVideos();
      this.descripcionValue = "";
      this.base64Value = "";
      this.filenameValue = "";
      //this.loadDataVideo();
    },
    async cargar() {
      let base64EncodedStr = this.base64Value;
      let filename = this.filenameValue;
      this.body = {
        archivo: base64EncodedStr,
        filename: filename,
        descripcion: this.descripcionValue,
      };
      return await axios
        .post("/public/CargaArchivoMultimedia", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          //this.reloadVideos();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
        });
    },
    loadNombreSelect() {
      let nom = [];
      this.itemsVideos.forEach(function (p) {
        let index = nom.findIndex((x) => x.filename == p.filename);
        if (index === -1) {
          nom.push(p.filename);
        }
      });
      this.nombreSelect = nom;
    },
    reloadVideos() {
      this.indexGridVideo += 1;
      this.adminAdjunto += 11;
      this.loadDataVideo();
    },
    clear() {
      this.nombreValue = "";
      this.loadDataVideo();
    },
    filterVideos() {
      this.filter = true;
      this.loadDataVideo();
    },
  },
};
</script>
